
export default {
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
        minQuery: {
            type: Number,
            default: 0
        },
    }
}
